// Páros termékek: az összevont opcióértékek ("Organikus pamut – S") gombra + lenyílóra bontva.
// A kiválasztást a rejtett Dawn rádiógombokra képezzük le, így a változatkeresés és
// az ár frissítése a téma saját (option_values alapú) útvonalán marad.
if (!customElements.get('ex-split-option')) {
  const SEP = ' – ';

  class ExSplitOption extends HTMLElement {
    static pendingFocus = null;
    // Szín: a variant-selects minden opcióváltáskor újrarenderelődik, a választott színt itt őrizzük meg.
    static colorMemory = {};

    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      this.select = this.querySelector('[data-ex-size]');
      if (this.select) {
        this.select.value = this.dataset.selected;
        this.select.addEventListener('change', (event) => {
          // A téma saját change-kezelője ne kapja meg: ez nem valódi opció-mező.
          event.stopPropagation();
          this.remember(`#${this.select.id}`);
          this.choose(this.select.value);
        });
      }

      this.querySelectorAll('[data-prefix]').forEach((button) => {
        button.addEventListener('click', () => {
          this.remember(`[data-prefix="${CSS.escape(button.dataset.prefix)}"]`, button);
          this.pickPrefix(button.dataset.prefix);
        });
      });

      this.bindColors();
      this.restoreFocus();
    }

    get index() {
      const root = this.closest('variant-selects');
      return root ? Array.from(root.querySelectorAll('ex-split-option')).indexOf(this) : -1;
    }

    bindColors() {
      this.colorInput = this.querySelector('[data-ex-color-input]');
      this.colorRadios = Array.from(this.querySelectorAll('.ex-split__swatch-input'));
      if (!this.colorInput || !this.colorRadios.length) return;

      const kind = this.dataset.colorKind || '';
      const memo = ExSplitOption.colorMemory[this.index];
      if (memo && memo.kind === kind) {
        const remembered = this.colorRadios.find((radio) => radio.value === memo.value);
        if (remembered) remembered.checked = true;
      }
      this.colorRadios.forEach((radio) => {
        radio.addEventListener('change', (event) => {
          // Nem opció-mező: a téma variant-selects change-kezelője ne fusson le rá.
          event.stopPropagation();
          this.applyColor();
        });
      });
      this.applyColor();
    }

    applyColor() {
      const checked = this.colorRadios.find((radio) => radio.checked) || this.colorRadios[0];
      if (!checked) return;
      checked.checked = true;
      this.colorInput.value = checked.value;
      const current = this.querySelector('[data-ex-color-current]');
      if (current) current.textContent = checked.dataset.display || checked.value;
      ExSplitOption.colorMemory[this.index] = { kind: this.dataset.colorKind || '', value: checked.value };
    }

    get natives() {
      return Array.from(this.querySelectorAll('.ex-split__native input[type="radio"]'));
    }

    usable(input) {
      return !input.classList.contains('disabled') && input.dataset.optionAvailable !== 'false';
    }

    pickPrefix(prefix) {
      const current = this.dataset.selected || '';
      const size = current.includes(SEP) ? current.split(SEP).pop() : current;
      const candidates = this.natives.filter((input) => input.value.startsWith(prefix + SEP));
      const target =
        candidates.find((input) => input.value === prefix + SEP + size && this.usable(input)) ||
        candidates.find((input) => this.usable(input)) ||
        candidates[0];
      if (target) this.choose(target.value);
    }

    choose(value) {
      const input = this.natives.find((candidate) => candidate.value === value);
      if (!input || input.checked) return;

      input.checked = true;
      this.dataset.selected = value;
      this.querySelectorAll('[data-prefix]').forEach((button) => {
        button.setAttribute('aria-pressed', String(value.startsWith(button.dataset.prefix + SEP)));
      });
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    remember(selector, element) {
      ExSplitOption.pendingFocus = { index: this.index, selector };
      element?.focus();
    }

    restoreFocus() {
      const pending = ExSplitOption.pendingFocus;
      if (!pending) return;
      const root = this.closest('variant-selects');
      if (!root || Array.from(root.querySelectorAll('ex-split-option')).indexOf(this) !== pending.index) return;
      // Az újrarenderelés után a fókusz maradjon azon a vezérlőn, amelyiket a vevő használt.
      requestAnimationFrame(() => {
        this.querySelector(pending.selector)?.focus();
        ExSplitOption.pendingFocus = null;
      });
    }
  }

  customElements.define('ex-split-option', ExSplitOption);
}
